import React, { useState, useEffect } from 'react';
import styles from '../../styles/TutorForm.module.css';

const MissingSizeAlert = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 10000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`${styles.missingSizeAlert} ${styles.fadeIn}`}>
      <div className={styles.alertContent}>
        <p className={styles.alertText}>Si no figuras en la lista de talles, acordate de hacer la selección de prendas en <b>mi cuenta blue</b> primero!</p>
        <button 
          onClick={handleClose} 
          className={styles.closeButton}
          aria-label="Cerrar aviso"
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  );
};

export default MissingSizeAlert;